/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Toast_Assign_ErrorInputs */

const vi_reconcile_toast_assign_error = /** @type {(inputs: Reconcile_Toast_Assign_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không gán được khoản CK vào đơn`)
};

/**

* @param {Reconcile_Toast_Assign_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_toast_assign_error = /** @type {((inputs?: Reconcile_Toast_Assign_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Toast_Assign_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_toast_assign_error(inputs)
});